
 
   import { useEffect, useState } from 'react';
   import {  InformationTransparency } from '../apiTypes';
   import { listElementsTrasparenzaInformativa } from '../functionApi';
   import { useAxiosInterceptor } from '../wrappers';

   export const useElementTrasparenzaInformativa = (reportId?: string, componentId?: string) => {
    useAxiosInterceptor(); // <--- monta l'interceptor
    const [elements, setElements] = useState<InformationTransparency[]>([]);
     const [loading, setLoading] = useState<boolean>(true);
     const [error, setError] = useState<string | null>(null);
   
     useEffect(() => {
       if (!reportId || !componentId) return;
   
       const fetchElements = async () => {
         setLoading(true);
         setError(null);
         try {
           const data = await listElementsTrasparenzaInformativa(reportId, componentId);
           setElements(data);
         } catch (err) {
           console.error(err);
           setError('Errore nel caricamento degli indici di penetrazione');
         } finally {
           setLoading(false);
         }
       };
   
       fetchElements();
     }, [reportId, componentId]);
   
     return { elements, loading, error };
   };
   
 

export default useElementTrasparenzaInformativa